// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CIjVz{text-align:center;width:100%;font-size:22px;color:#9ca0ad;padding-top:80px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyList": `CIjVz`
};
module.exports = ___CSS_LOADER_EXPORT___;
